// src/pages/dashboard/components/HealthRecordsCard.jsx
import { useMemo } from "react";
import { startOfMonth } from "date-fns";
import CircularProgress from "../../../../components/charts/CircularProgress";
import { useBpMonth } from "../../../../hooks/useHealthMetrics";

export default function HealthRecordsCard() {
    const month = startOfMonth(new Date());
    const { data: bpMonth = [] } = useBpMonth(month);

    // 최신 2개 추출 (dt 내림차순)
    const [latest1, latest2] = useMemo(() => {
        const sorted = [...bpMonth].sort((a, b) => new Date(b.dt) - new Date(a.dt));
        return [sorted[0] ?? null, sorted[1] ?? null];
    }, [bpMonth]);

    const renderLabel = (reading) => (
        <div className="flex flex-col items-center leading-tight">
            <span className="text-2xl md:text-3xl">{reading ? reading.sys : ""}</span>
            <span className="text-2xl md:text-3xl">{reading ? reading.dia : ""}</span>
        </div>
    );

    return (
        <div
            className="
            px-7 py-4 md:px-7 md:py-5
            bg-white rounded-2xl 
            flex items-center justify-center   
        "
        >
            <div className="flex flex-col items-center space-y-2">
                <p className="text-base md:text-lg font-bold">혈압</p>
                <CircularProgress
                    variant="ring"
                    color="#ED6363"
                    label={renderLabel(latest1)}
                    className="w-[120px] h-[120px] md:w-[120px] md:h-[120px]"
                    type="혈압"
                />
            </div>
        </div>
    );
}
